import LocationCategoryForm, {CategoryInput} from "pages/admin/category/form/LocationCategoryForm"
import {Category, CategoryLevel} from "dto/category/category"
import {AxiosError} from "axios"
import {useRegisterCategoryMutation} from "hooks/queries/category.query"

type Props = {
    level: CategoryLevel
    selectedCategory: Category | undefined
    close: () => void
}
export default function RegisterCategory({level, selectedCategory, close}: Props) {
    const registerCategory = useRegisterCategoryMutation()
    const onSubmit = (value: CategoryInput) => {
            const category: Category = {
                name: value.name,
                level,
                parentId: level === "DISTRICT" ? selectedCategory?.id : undefined,
                contactManager: value.contactManager,
            }
            registerCategory.mutate(category, {
                onSuccess: (data, variables, context) => {
                    console.log("success value : ", data, variables, context)
                    close()
                },
                onError: (err, variables, context) => {
                    const error = (err as AxiosError)
                    console.log("error value : ", error, variables, context)
                },
            })
            console.log("category form data : ", value)
        }

    return (
        <LocationCategoryForm
            show={true} close={() => close()}
            onSubmit={onSubmit}/>
    )
}